// node_modules
import { FC, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faCopy } from "@fortawesome/free-solid-svg-icons";
// Types
import { TAnswerResultDTO } from "Types";
// Helpers
import { NavigatorHelperSingleton, PendoHelperSingleton, uuid } from "Helpers";
import { MarkdownItComponent } from "Components/Shared";
// Styles
import styles from "./answers.module.scss";
// Controllers
import { LoggingControllerSingleton } from "Controllers";
import { LoggingConstants } from "Constants";

type TAnswersProps = {
    question: string,
    answerResults: TAnswerResultDTO[],
    answerResultsPreviewCount: number
}

export const Answers: FC<TAnswersProps> = ({question, answerResults, answerResultsPreviewCount}: TAnswersProps) => {
    // State
    const [isSeeMoreResultsClicked, setIsSeeMoreResultsClicked] = useState<boolean>(false);
    const [answerResultsDisplayed, setAnswerResultsDisplayed] = useState<TAnswerResultDTO[]>([]);

    // Logic
    useEffect(() => {
        if (isSeeMoreResultsClicked) {
            setAnswerResultsDisplayed([...answerResults]);
            return;
        }

        setAnswerResultsDisplayed([...answerResults.slice(0, answerResultsPreviewCount)]);
    }, [answerResults, answerResultsPreviewCount, isSeeMoreResultsClicked]);
    
    const copyAnswerResultDisplayedToClipboard = async (answerResultDisplayed: TAnswerResultDTO): Promise<void> => {
        if (!answerResultDisplayed) { return; }
        await NavigatorHelperSingleton.copyToClipboardAsync(answerResultDisplayed.answer);
        await LoggingControllerSingleton.copiedQAAnswerAsync({
            question: question,
            answer: answerResultDisplayed.answer,
            documentTitle: answerResultDisplayed.documentTitle,
            documentId: `${answerResultDisplayed.documentId}`
        });
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}CopiedQaAnswer`, {
            question: question,
            answer: answerResultDisplayed.answer,
            documentTitle: answerResultDisplayed.documentTitle,
            documentId: `${answerResultDisplayed.documentId}`
        });
    };

    return (
        <div className={styles.answerContainer}>
            {answerResultsDisplayed.map((answerResultDisplayed: TAnswerResultDTO) => (
                <div className={styles.answer} key={uuid()}>
                    <MarkdownItComponent source={answerResultDisplayed.answer} />
                    <div className={styles.copyAnswer} title={"Copy"} onClick={() => copyAnswerResultDisplayedToClipboard(answerResultDisplayed)} >
                        <FontAwesomeIcon icon={faCopy}/>
                    </div>
                </div>
            ))}
            {answerResults.length > answerResultsPreviewCount ?
                <span className={styles.seeMoreResultsToggle} onClick={() => setIsSeeMoreResultsClicked(!isSeeMoreResultsClicked)}>  
                    {isSeeMoreResultsClicked ? "See less results" : "See more results"}
                    <FontAwesomeIcon 
                        icon={isSeeMoreResultsClicked ? faAngleUp : faAngleDown}/>
                </span>
                : null
            }
        </div>
    );
};